import React, { Component } from 'react';

import { isEmptyObjValues } from 'utils/ramdaAdditions';
import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';
import { PersonEmails } from '../fields/PersonEmails';
import { PersonPhone } from '../fields/PersonPhone';
import { PersonWebPages } from '../fields/PersonWebPages';
import { PersonMessengers } from '../fields/PersonMessengers';

class PersonContacts extends Component {
    render() {
        const { emails, phone, webs, messengers } = this.props;

        return !isEmptyObjValues(this.props) ? (
            <div className='person-contact'>
                <DefinitionHeader translate="person.contacts.title" iconType="phone-circle" />
                <div className="panel-view">
                    <PersonEmails emails={emails} />
                    <PersonPhone phone={phone} />
                    <PersonMessengers messengers={messengers} />
                    <PersonWebPages webs={webs} />
                </div>
            </div>
        ) : null;
    }
}

export default PersonContacts;
